import {
  FMSPaymentInterface,
  GetPaymentSessionSummaryPayload,
  MakePaymentQueuedResponse,
  PaymentSessionInterface,
  PaymentSessionMode,
  PaymentSessionStatus,
  PaymentUserRecordInterface
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - ../../../../apps/server/src/API/Leases/Leases.Controller.ts
export class PaymentsAPI {
  static async createPaymentUserRecord(orgId: number, paymentUserRecord?: Partial<PaymentUserRecordInterface>) {
    return APIService.Server.post<PaymentUserRecordInterface>(`/payments/org/${orgId}/payment-user-record`, paymentUserRecord);
  }

  static async getStoreFormUrl(sessionId: string, parentUrl: string) {
    return APIService.Server.get<string | null>(`/payments/session/${sessionId}/store-form-url`, { parentUrl });
  }

  static async openPaymentSession(sessionId: string, token: string) {
    return APIService.Server.post<PaymentSessionInterface>(`/payments/session/open`, { sessionId, token });
  }

  static async getPaymentSessionSummary(payload: GetPaymentSessionSummaryPayload) {
    return APIService.Server.post<PaymentSessionInterface>(`/payments/session/summary`, payload);
  }

  static async regeneratePaymentSession(sessionId: string, token: string) {
    return APIService.Server.post<PaymentSessionInterface>(`/payments/session/${sessionId}/regenerate`, { token });
  }

  static async getPaymentSession(sessionId: string) {
    return APIService.Server.get<PaymentSessionInterface>(`/payments/session/${sessionId}`);
  }

  static async updatePaymentSession(sessionId: string, payload: Partial<PaymentSessionInterface>) {
    return APIService.Server.put<PaymentSessionInterface>(`/payments/session/${sessionId}`, payload);
  }

  static async verifyPaymentSessionSignature(sessionId: string, signature: string) {
    return APIService.Server.post<boolean>(`/payments/session/${sessionId}/verify-signature`, { signature });
  }

  static async makePayment(sessionId: string, token: string, payment: FMSPaymentInterface) {
    return APIService.Server.post<MakePaymentQueuedResponse>(`/fms/payments/session/${sessionId}/make-payment`, {
      signature: token,
      payment
    });
  }

  static async closePaymentSession(sessionId: string, signature: string, status: PaymentSessionStatus) {
    return APIService.Server.post<void>(`/payments/session/${sessionId}/close`, { signature, status });
  }

  static async broadcastPaymentSessionStatus(sessionId: string, payload: { orgId: number; userId: number; status: PaymentSessionStatus }) {
    return APIService.Server.post<void>(`/payments/session/${sessionId}/broadcast-status`, payload);
  }

  static async getPaymentLink(
    orgId: number,
    userId: number,
    options?: { expirationInMinutes?: number; mode?: PaymentSessionMode; channel?: string; source?: string }
  ) {
    return APIService.Server.get<{ url: string }>(`/payments/org/${orgId}/user/${userId}/payment-link`, {
      expirationInMinutes: options?.expirationInMinutes,
      mode: options?.mode,
      channel: options?.channel,
      source: options?.source
    });
  }
}
